import { render, staticRenderFns } from "./FormThuxHorizontalDatetimePicker.vue?vue&type=template&id=b38c80d6&"
import script from "./FormThuxHorizontalDatetimePicker.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalDatetimePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports